export function CriticalIcon(props) {
  return (
    <svg
      height='24'
      style={{ padding: '1.25px' }}
      viewBox='0 0 256 256'
      width='24'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <path d='M210.9,146.9a72.2,72.2,0,0,1-79.8,15L79,222.2c-.1.1-.2.3-.4.4a31.9,31.9,0,0,1-45.2,0,31.9,31.9,0,0,1,0-45.2c.1-.2.3-.3.4-.4l60.3-52.1a72,72,0,0,1,94-95.2,8.3,8.3,0,0,1,4.4,4.6,7.7,7.7,0,0,1-.4,6.3,5.1,5.1,0,0,1-1.5,2.1l-38.9,39,3.8,18.8,18.8,3.8,39-38.9a5.1,5.1,0,0,1,2.1-1.5,7.7,7.7,0,0,1,6.3-.4,8.3,8.3,0,0,1,4.6,4.4A71.6,71.6,0,0,1,210.9,146.9Z' />
    </svg>
  );
}
